module.exports = __webpack_public_path__ + "media/src/components/shared/general/img/logo-23d3b3329a6dd11c98cfc8bd59d39956.png";